import React, { useState } from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button } from 'antd'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { Link } from 'react-router-dom'
import StatusFilter, { statusFilterMethod } from '../../../components/Corporate/Requisitions/TableComponents/StatusFilter.js'

function List (props) {
  const { list, fetch, fetching, onShow, company, onChangeCompany } = props
  const [filtered, setFiltered] = useState([{ id: 'status', value: 'active' }])
  const [count, setCount] = useState(0) // weired bug that react only fire render with this

  const columns = [
    {
      Header: 'Code',
      accessor: 'code',
      width: 150,
      Cell: ({ value, original }) => (
        <Link
          to={{
            pathname: `/purchasing/requisitions/${original._key}/update`,
          }}>
          {value}
        </Link>
      ),
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      hideable: true,
      hideDefault: true
    },
    {
      Header: 'Sales Order',
      accessor: 'sales.code',
      width: 150,
    },
    {
      Header: 'Title',
      accessor: 'title',
      alignment: 'left',
      textAlign: 'left',
    },
    {
      Header: 'Requested By',
      accessor: 'owner.fn',
      hideable: true,
      hideDefault: true,
      width: 250,
    },
    {
      Header: 'Type',
      accessor: 'type',
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Currency',
      accessor: 'currency',
      width: 150,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      Cell: MoneyCell,
      width: 150,
    },
    {
      Header: 'Converted',
      accessor: 'converted',
      Cell: MoneyCell,
      hideable: true,
      hideDefault: true,
      width: 150,
    },
    {
      Header: 'To Bill',
      accessor: 'toBill',
      Cell: MoneyCell,
      hideable: true,
      hideDefault: true,
    },
    {
      Header: 'Date',
      accessor: 'date',
      Cell: DateCell,
      width: 150,
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell,
      filterMethod: statusFilterMethod,
      Filter: StatusFilter,
      width: 200,
    },
  ]

  function onFilteredChangeCustom (value, accessor) {
    let newFiltered = filtered
    let insertNewFilter = 1
    value = value || ''
    if (newFiltered.length > 0) {
      newFiltered.forEach((filter, i) => {
        if (filter['id'] === accessor) {
          if (value === '' || !value.length) newFiltered.splice(i, 1)
          else filter['value'] = value
          insertNewFilter = 0
        }
      })
    }
    if (insertNewFilter) {
      newFiltered.push({ id: accessor, value: value })
    }
    setCount(count + 1) // and this one as well
    console.log({ newFiltered })
    setFiltered(newFiltered)
  }

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      show={{ extraColumns: true }}
      fetch={fetch}
      ExtraOptionsButtons={() => (
        <OrganisationsSelect
          value={company}
          onChange={onChangeCompany}
          placeholder={'Filter by a company'}
          size={'small'}
          style={{ width: '450px', paddingRight: 20, float: 'right' }}
        />
      )}
      CreateButton={() => (
        <Button data-testid={'add'} type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          New{' '}
        </Button>
      )}
      onFilteredChange={(filtered, column, value) => {
        onFilteredChangeCustom(value, column.id || column.accessor)
      }}
      filtered={filtered}
      columns={columns}
    />
  )
}

List.propTypes = {}
List.defaultProps = {}

export default List
